import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="py-10 md:py-14 px-4 md:px-6 bg-foreground-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div className="md:col-span-1">
            <h3 className="text-lg font-heading font-bold text-white mb-3">
              Basetao Sheet
            </h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              The #1 Basetao Spreadsheet Resource Hub. Reviews, shipping guides, templates &amp; buying tools to help you shop smarter.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-3">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors duration-150">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/article/ultimate-basetao-spreadsheet-guide" className="text-sm text-foreground-400 hover:text-white transition-colors duration-150">
                  Shopping Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-white transition-colors duration-150"
                >
                  Basetao Spreadsheet Shop
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-3">
              Popular Categories
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://kaspreadsheet.com/category-911-Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-white transition-colors duration-150"
                >
                  Shoes
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/search-913/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-white transition-colors duration-150"
                >
                  T-Shirts
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-white transition-colors duration-150"
                >
                  Hoodies / Sweaters
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com/search-914/name/Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-white transition-colors duration-150"
                >
                  Jackets
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-3">
              Top Guides
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/basetao-shipping-cost-guide" className="text-sm text-foreground-400 hover:text-white transition-colors duration-150">
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link to="/article/basetao-review-2026" className="text-sm text-foreground-400 hover:text-white transition-colors duration-150">
                  Basetao Review 2026
                </Link>
              </li>
              <li>
                <Link to="/article/is-basetao-legit" className="text-sm text-foreground-400 hover:text-white transition-colors duration-150">
                  Is Basetao Legit?
                </Link>
              </li>
              <li>
                <Link to="/article/basetao-beginners-guide" className="text-sm text-foreground-400 hover:text-white transition-colors duration-150">
                  Beginners Guide
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Basetao Sheet. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-150">
              Privacy Policy
            </Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-150">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}